import { useId, useState } from 'react';
export default function Dropdown({ items, name, selected, label, defaultOptionLabel, triggerChange }) {

    const itemId = useId();

    const listItems = items.map(item =>
        <option key={item.name} value={item.value}>
            {item.name}
        </option>
    );

    return (
        <div>
            {label && <label htmlFor={itemId} className="text-h5">{label}:</label>}
            <select id={itemId} name={name} defaultValue={selected} onChange={triggerChange}>
                {defaultOptionLabel && <option value="-1">{defaultOptionLabel}</option>}
                {listItems}
            </select>
        </div>
    );
}